import { useEffect, useRef, useState } from "react";
import Swal from "sweetalert2";
import {
  ButtonTab,
  Container,
  ContainerButton,
  ContainerCount,
  ContainerPages,
  LabelCountBlue,
  LabelCountRed,
  Menu,
  OptionsContainer,
} from "./styles";
import Button from "../../components/Button/button";
import { HiDocumentArrowUp, HiDocumentPlus } from "react-icons/hi2";
import { Label } from "../../components/Label/styles";
import {
  BlueTitle,
  GrayTitle,
  LoadingGif,
  LoadingOverlay,
  ModalBody,
  ModalBodyContainer,
  ModalContainer,
  ModalContent,
  ModalFooter,
  ModalHeader,
  StyledHR,
  TextError,
  TitleAndButton,
} from "../../shared/styles/global.styles";
import { IoCloseSharp } from "react-icons/io5";
import FichaFinanceiraService from "../../services/FichaFinanceiraService";
import {
  StatusRemessaBaixaEnum,
  StatusRemessaEnum,
} from "../../shared/enum/fichaFinanceira.enum";
import ListarRemessas from "./ListarRemessas/ListarRemessa";
import { StatusRemessa, TypeRemessa } from "../../shared/enum/remessas.enum";
import loadSCGif from "../../assets/load_SC.gif";
import { Form } from "react-bootstrap";
import ListarRemessasRetorno from "./ListarRetornos/ListarRetornos";
import { LocalPagamentoDto } from "../../shared/dtos/LocalPagamento.dto";
import localPagamentoService from "../../services/LocalPagamentoService";
import SelectComponent from "../../components/Select/select";
import { DatePickerInputContainer } from "../../components/Input/styles";
import DatePicker from "react-datepicker";
import { Lotacao } from "../../shared/interfaces/DadosFinanceirosInterface";
import lotacaoService from "../../services/LotacaoService";
import { useAuth } from "../../AuthContext/AuthContext";
import { ModulosEnum } from "../../shared/enum/modulos.enum";
import { PermissoesEnum } from "../../shared/enum/permicao.enum";
import { TypeLayoutRemessaRetornoEnum } from "../../shared/enum/layoutRemessaRetorno.enum";
import { GetRetornoDto } from "../../shared/dtos/Retorno.dto";
import { StatusRetorno } from "../../shared/enum/retorno.enum";
import { progressBarSwalAlert } from "../../components/ProgressBarSwalAlert/ProgressBarSwalAlert";
import { Colors } from "../../shared/colors/colors";
import requestInProgressService from "../../services/RequestInProgressService";

const Remessas: React.FC = () => {
  const { checkPermission } = useAuth();
  const editRemessaOnly = checkPermission(
    ModulosEnum.REMESSAS,
    PermissoesEnum.ESCRITA
  );
  const editRetornosOnly = checkPermission(
    ModulosEnum.RETORNOS,
    PermissoesEnum.ESCRITA
  );
  const readRemessaOnly = checkPermission(
    ModulosEnum.REMESSAS,
    PermissoesEnum.LEITURA
  );
  const readRetornosOnly = checkPermission(
    ModulosEnum.RETORNOS,
    PermissoesEnum.LEITURA
  );

  const checkOpenTab = () => {
    if (editRemessaOnly || readRemessaOnly) {
      setSelectTab(0);
      return;
    }
    if (editRemessaOnly || readRetornosOnly) {
      setSelectTab(5);
      return;
    }
  };

  const fileInputRef = useRef<HTMLInputElement>(null);
  const [locaisPagamento, setLocaisPagamento] = useState<LocalPagamentoDto[]>(
    []
  );
  const [lotacoes, setLotacoes] = useState<Lotacao[]>([]);
  const [invalidFields, setInvalidFields] = useState<string[]>([]);
  const [selectTab, setSelectTab] = useState<number>(0); // Inicializa com 0
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isRequest, setIsRequest] = useState<boolean>(false);
  const [showModalNewRemittance, setShowModalNewRemittance] =
    useState<boolean>(false);
  const [showModalUploadRemittance, setShowModalUploadRemittance] =
    useState<boolean>(false);
  const [quantityRemittances, setQuantityRemittances] = useState<number>(0);
  const [totalFichasFinanceiras, setTotalFichasFinanceiras] =
    useState<number>(-1);
  const [quantityRemittancesBaixa, setQuantityRemittancesBaixa] =
    useState<number>(0);
  const [totalFichasFinanceirasBaixa, setTotalFichasFinanceirasBaixa] =
    useState<number>(0);

  const [fileReturnRemittance, setFileReturnRemittance] = useState<File | null>(
    null
  );
  const [reloadFunction, setReloadFunction] = useState<boolean>(false);
  // const [typeRemittance, setTypeRemittance] = useState<TypeRemessa>(
  //   TypeRemessa.BOLETO
  // );
  const [selectLocalPagamento, setSelectLocalPagamento] =
    useState<LocalPagamentoDto>();
  const [selectLotacao, setSelectLotacao] = useState<Lotacao>();
  const [dateRange, setDateRange] = useState<
    [Date | undefined, Date | undefined]
  >([undefined, undefined]);
  const [selectedRetorno, setSelectedRetorno] = useState<
    GetRetornoDto | undefined
  >();

  const handleSelectTab = (index: number) => {
    setSelectTab(index);
  };

  const clearError = (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
  ) => {
    const { name } = event.target;

    setInvalidFields((prev) => prev.filter((field) => field !== name));
  };

  const fetchLocaisPagamento = async () => {
    try {
      const response =
        await localPagamentoService.getAllLocaisPagamentoWithLayoutRemessaRetorno();
      setLocaisPagamento(response);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Erro ao buscar locais de pagamento",
        allowOutsideClick: false,
      });
    }
  };

  const fetchLotacoes = async () => {
    try {
      const response = await lotacaoService.getAllLotacoes();
      setLotacoes(response);
    } catch (error) {
      Swal.fire({
        title: "Erro",
        text: "Erro ao buscar lotações. Por favor, tente novamente.",
        icon: "error",
        confirmButtonText: "Fechar",
        allowOutsideClick: false,
      });
    }
  };

  const getTotalFichasFinanceiras = async () => {
    if (
      dateRange[0] &&
      dateRange[1] &&
      // typeRemittance &&
      selectLocalPagamento &&
      selectLocalPagamento.id
    ) {
      setIsRequest(true);
      const dataStatusRemessa = {
        status: StatusRemessaEnum.ENVIAR,
        // typeRemessa: typeRemittance,
        idLocalPagamento: selectLocalPagamento.id,
        idLotacao: selectLotacao ? selectLotacao.id : undefined,
        dateInitial: dateRange[0],
        dateFinal: dateRange[1],
      };

      await FichaFinanceiraService.countParcelasByStatusRemessaAndLocalPagamento(
        dataStatusRemessa
      )
        .then((result) => {
          setQuantityRemittances(result);
          setTotalFichasFinanceiras(result);
        })
        .catch((error) => {
          console.error(error);
          Swal.fire({
            icon: "error",
            title: "Erro ao verificar total de fichas financeiras",
            text:
              error.message || "Ocorreu um erro ao processar sua solicitação",
            confirmButtonText: "OK",
            allowOutsideClick: false,
          });
          setQuantityRemittances(0);
          setTotalFichasFinanceiras(-1);
        });

      setIsRequest(false);
    }
  };

  const getTotalCancelFichaFinanceiras = async () => {
    if (selectLocalPagamento && selectLocalPagamento.id) {
      const dataStatusRemessaBaixa = {
        status: StatusRemessaBaixaEnum.ENVIAR,
        idLocalPagamento: selectLocalPagamento?.id,
      };
      await FichaFinanceiraService.countParcelasByStatusRemessaBaixaAndLocalPagamento(
        dataStatusRemessaBaixa
      )
        .then((result) => {
          setQuantityRemittancesBaixa(result);
          setTotalFichasFinanceirasBaixa(result);
        })
        .catch((error) => {
          console.error(error);
          Swal.fire({
            icon: "error",
            title: "Erro ao verificar total de fichas financeiras",
            text:
              error.message || "Ocorreu um erro ao processar sua solicitação",
            confirmButtonText: "OK",
            allowOutsideClick: false,
          });
          setQuantityRemittances(0);
          setTotalFichasFinanceiras(-1);
        });
    }
  };

  const openModalUploadRemittance = () => {
    setFileReturnRemittance(null);
    setShowModalUploadRemittance(true);
  };

  const createRemittanceMass = async (FichasFinanceirasBaixa: number) => {
    setIsRequest(true);
    setIsLoading(true);

    const newInvalidFields: string[] = [];

    if (FichasFinanceirasBaixa <= 0) {
      if ((!dateRange[0] && !dateRange[1]) || !dateRange[0] || !dateRange[1]) {
        newInvalidFields.push("dataVencimento");
      }

      if (!selectLocalPagamento) {
        newInvalidFields.push("localPagamento");
      }

      if (newInvalidFields.length > 0) {
        setInvalidFields(newInvalidFields);

        Swal.fire({
          icon: "error",
          title: "Erro nos campos",
          text: "Por favor, preencha todos os campos obrigatórios.",
          confirmButtonText: "OK",
          allowOutsideClick: false,
        });

        setIsRequest(false);
        setIsLoading(false);
        return;
      }
    }
    const nameTypeRemittance = selectLocalPagamento?.descricao;

    const result = await Swal.fire({
      title: "Confirmar",
      text:
        quantityRemittances > 0
          ? `Deseja criar uma remessa de ${nameTypeRemittance} com ${quantityRemittances} fichas financeiras?`
          : `Deseja criar uma remessa de ${nameTypeRemittance} fichas financeiras ${
              quantityRemittancesBaixa > 0
                ? `e ${quantityRemittancesBaixa} fichas financeiras canceladas?`
                : "?"
            }`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Cancelar",
      allowOutsideClick: false,
    });

    if (result.isConfirmed) {
      Swal.fire({
        title: "Criando remessa...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      const data = {
        idLocalPagamento: selectLocalPagamento?.id!,
        dateInitial: dateRange[0]?.toISOString(),
        dateFinal: dateRange[1]?.toISOString(),
        idLotacao: selectLotacao?.id!,
      };
      await FichaFinanceiraService.createRemittanceMass(data).then(
        async (responseRemessa) => {
          if (responseRemessa.success) {
            Swal.fire({
              title: "Processando solicitação",
              html: progressBarSwalAlert({
                currentProgress: 0,
                totalProgress: 0,
                color: Colors.primary,
                showProgressText: true,
              }),
              showConfirmButton: false,
              allowOutsideClick: false,
              didOpen: () => {
                Swal.showLoading();
              },
            });

            let stopLoopRemessa = false;
            let getRequestInProgressRemessa =
              await requestInProgressService.getRequestInProgressById(
                responseRemessa.data.id
              );
            await new Promise((resolve) => setTimeout(resolve, 2000));

            while (!stopLoopRemessa) {
              getRequestInProgressRemessa =
                await requestInProgressService.getRequestInProgressById(
                  responseRemessa.data.id
                );

              if (getRequestInProgressRemessa.finished) {
                stopLoopRemessa = true;
              } else {
                Swal.update({
                  html: progressBarSwalAlert({
                    currentProgress:
                      getRequestInProgressRemessa.currentProgress,
                    totalProgress: getRequestInProgressRemessa.totalProgress,
                    color: Colors.primary,
                    showProgressText: true,
                    progressText: "Gerando Remessa aguarde...",
                  }),
                });
                await new Promise((resolve) => setTimeout(resolve, 2000));
              }
            }
            await requestInProgressService.deleteRequestInProgress(
              responseRemessa.data.id
            );
            if (!getRequestInProgressRemessa.error) {
              if (getRequestInProgressRemessa.responseData) {
                const response: any | undefined = JSON.parse(
                  getRequestInProgressRemessa.responseData
                );
                if (response) {
                  Swal.fire({
                    icon: "success",
                    title: "Sucesso",
                    text: "Remessa criada com sucesso!",
                    allowOutsideClick: false,
                  });
                  setIsRequest(false);
                  setIsLoading(false);
                }
              } else {
                Swal.fire({
                  title: "Erro",
                  text: getRequestInProgressRemessa.message,
                  icon: "error",
                  confirmButtonText: "OK",
                  allowOutsideClick: false,
                });
              }
            } else {
              Swal.fire({
                title: "Erro",
                text: getRequestInProgressRemessa.message,
                icon: "error",
                confirmButtonText: "OK",
                allowOutsideClick: false,
              });
            }
          } else {
            Swal.fire({
              icon: "error",
              title: "Erro ao gerar remessa",
              text: "Ocorreu um erro ao solicitar a remessa. Por favor, tente novamente.",
              confirmButtonText: "OK",
              allowOutsideClick: false,
            });
          }
        }
      );

    }
    closeNewRemittanceModal();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const fileList = event.target.files;
    if (fileList?.length === 0 || !fileList) {
      return;
    }
    const file = fileList[0];
    const fileType = file.type;
    // if (
    //   fileType !== "text/rem" &&
    //   fileType !== "text/plain" &&
    //   fileType !== "application/octet-stream" &&
    //   fileType !== "text/plain" &&
    //   fileType !== "text/txt" &&
    //   fileType !== "text/rtf" &&
    //   fileType !== ""
    // ) {
    //   Swal.fire({
    //     icon: "error",
    //     title: "Erro ao carregar o arquivo",
    //     text: "O arquivo deve ser do tipo .rem ou .txt",
    //     allowOutsideClick: false,
    //   });
    //   return;
    // }
    setFileReturnRemittance(file);
  };

  const handleUploadReturnRemittance = async () => {
    setIsRequest(true);
    if (fileReturnRemittance) {
      Swal.fire({
        title: "Deseja carregar o arquivo?",
        text: `Deseja carregar o arquivo de retorno: ${fileReturnRemittance?.name}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, carregar",
        cancelButtonText: "Cancelar",
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "Carregando arquivo de retorno, aguarde...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
          await FichaFinanceiraService.uploadFileRemessaRetornoSicredi(
            fileReturnRemittance!
          )
            .then(async (responseRetorno) => {
              if (responseRetorno.success) {
                Swal.fire({
                  title: "Processando solicitação",
                  html: progressBarSwalAlert({
                    currentProgress: 0,
                    totalProgress: 0,
                    color: Colors.primary,
                    showProgressText: true,
                  }),
                  showConfirmButton: false,
                  allowOutsideClick: false,
                  didOpen: () => {
                    Swal.showLoading();
                  },
                });

                let stopLoopRetorno = false;
                let getRequestInProgressRetorno =
                  await requestInProgressService.getRequestInProgressById(
                    responseRetorno.data.id
                  );
                await new Promise((resolve) => setTimeout(resolve, 2000));

                while (!stopLoopRetorno) {
                  getRequestInProgressRetorno =
                    await requestInProgressService.getRequestInProgressById(
                      responseRetorno.data.id
                    );

                  if (getRequestInProgressRetorno.finished) {
                    stopLoopRetorno = true;
                  } else {
                    Swal.update({
                      html: progressBarSwalAlert({
                        currentProgress:
                          getRequestInProgressRetorno.currentProgress,
                        totalProgress:
                          getRequestInProgressRetorno.totalProgress,
                        color: Colors.primary,
                        showProgressText: true,
                        progressText: "Análisando arquivo de retorno aguarde...",
                      }),
                    });
                    await new Promise((resolve) => setTimeout(resolve, 2000));
                  }
                }
                await requestInProgressService.deleteRequestInProgress(
                  responseRetorno.data.id
                );
                if (!getRequestInProgressRetorno.error) {
                  if (getRequestInProgressRetorno.responseData) {
                    const response: any | undefined = JSON.parse(
                      getRequestInProgressRetorno.responseData
                    );
                    if (response.status === StatusRetorno.SUCCESS) {
                      Swal.fire({
                        icon: "success",
                        title: "Sucesso",
                        text: "Arquivo de retorno carregado com sucesso!",
                        allowOutsideClick: false,
                        confirmButtonText: "OK",
                      }).then((result) => {
                        if (result.isConfirmed) {
                          setSelectedRetorno(response.data);
                          setSelectTab(5);
                        }
                      });
                      setIsRequest(false);
                      return;
                    }
                    if (response.status === StatusRetorno.NO_CHANGE) {
                      Swal.fire({
                        icon: "warning",
                        title: "Aviso",
                        text: "Arquivo de retorno carregado com sucesso! Nenhuma alteração foi feita.",
                        allowOutsideClick: false,
                        confirmButtonText: "OK",
                      }).then((result) => {
                        if (result.isConfirmed) {
                          setSelectedRetorno(response.data);
                          setSelectTab(5);
                        }
                      });
                      setIsRequest(false);
                      return;
                    }
                  } else {
                    Swal.fire({
                      title: "Erro",
                      text: getRequestInProgressRetorno.message,
                      icon: "error",
                      confirmButtonText: "OK",
                      allowOutsideClick: false,
                    });
                  }
                } else {
                  Swal.fire({
                    title: "Erro",
                    text: getRequestInProgressRetorno.message,
                    icon: "error",
                    confirmButtonText: "OK",
                    allowOutsideClick: false,
                  });
                }
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Erro ao gerar Remessa",
                  text: "Ocorreu um erro ao solicitar o cadastro das parcelas. Por favor, tente novamente.",
                  confirmButtonText: "OK",
                  allowOutsideClick: false,
                });
              }
            })
            .catch((error) => {
              console.error(error);
              Swal.fire({
                icon: "error",
                title: "Erro",
                text: error.message,
                allowOutsideClick: false,
              });
              setSelectTab(5);
            });
        }
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Erro ao carregar o arquivo",
        text: "Nenhum arquivo foi carregado",
        allowOutsideClick: false,
      });
    }
    setIsRequest(false);
    setShowModalUploadRemittance(false);
    setFileReturnRemittance(null);
    // setTypeRemittance(TypeRemessa.BOLETO);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleDateRangeChange = (dates: [Date | null, Date | null]) => {
    // Convertendo valores null para undefined
    const [start, end] = dates;

    if (start) {
      setDateRange([start, dateRange[1]]);
    }
    if (end) {
      setDateRange([dateRange[0], end]);
    }
  };

  // Função para formatar a entrada manual de datas
  const handleDateInputChange = (e: any) => {
    if (!e || !e.target || typeof e.target.value !== "string") return;

    let value = e.target.value;

    // Não fazer nada se o campo estiver vazio
    if (!value) return;

    // Verificar se o valor contém hífen (separando intervalo de datas)
    const parts = value.split("-");

    if (parts.length > 1) {
      // Processar intervalo de datas (início - fim)
      let startDate = parts[0].trim();
      let endDate = parts[1].trim();

      // Formatar a primeira data
      startDate = formatDateInput(startDate);

      // Formatar a segunda data
      endDate = formatDateInput(endDate);

      // Recompor o valor com o formato correto
      e.target.value = `${startDate} - ${endDate}`;
    } else {
      // Processar uma única data
      const formattedDate = formatDateInput(value);

      // Verificar se a primeira data está completa (10 caracteres = dd/mm/aaaa)
      // Se estiver completa e não for uma operação de apagar (verificar se o valor atual é maior que o anterior)
      if (formattedDate.length === 10 && value.length >= formattedDate.length) {
        // Adicionar o hífen automaticamente
        e.target.value = `${formattedDate} - `;
      } else {
        e.target.value = formattedDate;
      }
    }
  };

  // Função auxiliar para formatar uma data individual
  const formatDateInput = (value: string): string => {
    // Remover caracteres não numéricos
    let numbers = value.replace(/\D/g, "");

    // Limitar a 8 dígitos (ddmmyyyy)
    numbers = numbers.substring(0, 8);

    // Aplicar máscara dd/mm/yyyy
    let formattedValue = "";
    if (numbers.length > 0) {
      formattedValue = numbers.substring(0, Math.min(2, numbers.length));

      if (numbers.length > 2) {
        formattedValue +=
          "/" + numbers.substring(2, Math.min(4, numbers.length));
      }

      if (numbers.length > 4) {
        formattedValue +=
          "/" + numbers.substring(4, Math.min(8, numbers.length));
      }
    }

    return formattedValue;
  };

  const closeNewRemittanceModal = () => {
    setDateRange([undefined, undefined]);
    // setTypeRemittance(TypeRemessa.BOLETO);
    setSelectLocalPagamento(undefined);
    setSelectLotacao(undefined);
    setQuantityRemittances(0);
    setTotalFichasFinanceiras(-1);
    setQuantityRemittancesBaixa(0);
    setTotalFichasFinanceirasBaixa(0);
    setInvalidFields([]);
    setShowModalNewRemittance(false);
    setIsRequest(false);
    setIsLoading(false);
    checkOpenTab();
  };

  useEffect(() => {
    checkOpenTab();
    fetchLocaisPagamento();
    fetchLotacoes();
  }, []);

  useEffect(() => {
    getTotalFichasFinanceiras();
    getTotalCancelFichaFinanceiras();
  }, [selectLocalPagamento, dateRange, selectLotacao]);

  useEffect(() => {
    if (reloadFunction) {
      setReloadFunction(false);
    }
  }, [reloadFunction]);

  return (
    <>
      {!isLoading ? (
        <Container>
          <TitleAndButton>
            <GrayTitle>
              {readRemessaOnly && readRetornosOnly
                ? "Remessas e Retornos"
                : readRemessaOnly
                ? "Remessas"
                : "Retornos"}
            </GrayTitle>
            <ContainerButton>
              {editRemessaOnly && (
                <Button
                  schemaButton="full-primary"
                  action={() => setShowModalNewRemittance(true)}
                  icon={
                    <HiDocumentPlus
                      style={{ fontSize: "1.3rem", marginRight: "0.3rem" }}
                    />
                  }
                  disabled={isRequest}
                >
                  Criar nova remessa
                </Button>
              )}
              {editRetornosOnly && (
                <Button
                  schemaButton="out-primary"
                  action={() => openModalUploadRemittance()}
                  icon={
                    <HiDocumentArrowUp
                      style={{ fontSize: "1.3rem", marginRight: "0.3rem" }}
                    />
                  }
                  disabled={isRequest}
                >
                  Carregar arquivo de retorno
                </Button>
              )}
            </ContainerButton>
          </TitleAndButton>
          <StyledHR />
          <Menu
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <OptionsContainer
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "flex-start",
              }}
            >
              {readRemessaOnly && (
                <>
                  <ButtonTab
                    onClick={() => {
                      handleSelectTab(0);
                    }}
                    active={selectTab === 0}
                    disabled={isRequest}
                  >
                    Remessas criadas
                  </ButtonTab>
                  <ButtonTab
                    onClick={() => {
                      handleSelectTab(1);
                    }}
                    active={selectTab === 1}
                    disabled={isRequest}
                  >
                    Remessas enviadas
                  </ButtonTab>
                  <ButtonTab
                    onClick={() => {
                      handleSelectTab(3);
                    }}
                    active={selectTab === 3}
                    disabled={isRequest}
                  >
                    Remessas canceladas
                  </ButtonTab>
                  <ButtonTab
                    onClick={() => {
                      handleSelectTab(4);
                    }}
                    active={selectTab === 4}
                    disabled={isRequest}
                  >
                    Todas Remessas
                  </ButtonTab>
                </>
              )}
              {readRetornosOnly && (
                <ButtonTab
                  onClick={() => {
                    handleSelectTab(5);
                  }}
                  active={selectTab === 5}
                  disabled={isRequest}
                >
                  Retornos carregados
                </ButtonTab>
              )}
            </OptionsContainer>
          </Menu>

          <ContainerPages>
            {(() => {
              switch (selectTab) {
                case 0:
                  return (
                    <ListarRemessas
                      status={StatusRemessa.CRIADO}
                      setReloadFunction={setReloadFunction}
                      editOnly={editRemessaOnly}
                    />
                  );
                case 1:
                  return (
                    <ListarRemessas
                      status={StatusRemessa.ENVIADO}
                      setReloadFunction={setReloadFunction}
                      editOnly={editRemessaOnly}
                    />
                  );
                case 2:
                  return (
                    <ListarRemessas
                      status={StatusRemessa.RECUSADA}
                      setReloadFunction={setReloadFunction}
                      editOnly={editRemessaOnly}
                    />
                  );
                case 3:
                  return (
                    <ListarRemessas
                      status={StatusRemessa.CANCELADO}
                      setReloadFunction={setReloadFunction}
                      editOnly={editRemessaOnly}
                    />
                  );
                case 4:
                  return (
                    <ListarRemessas
                      status={null}
                      setReloadFunction={setReloadFunction}
                      editOnly={editRemessaOnly}
                    />
                  );
                case 5:
                  return (
                    <ListarRemessasRetorno
                      editOnly={editRetornosOnly}
                      selectedRetorno={selectedRetorno}
                      setSelectedRetorno={setSelectedRetorno}
                    />
                  );
                default:
                  return null;
              }
            })()}
          </ContainerPages>

          <ModalContainer show={showModalNewRemittance}>
            <ModalContent style={{ marginTop: "2%" }} width={35}>
              <Button
                type="button"
                schemaButton="x-close"
                action={() => closeNewRemittanceModal()}
                icon={<IoCloseSharp size={30} />}
                position="absolute"
                top={10}
                right={10}
              />
              <ModalHeader>
                <BlueTitle>Gerar remessa</BlueTitle>
              </ModalHeader>
              <ModalBody>
                {/* <Label htmlFor="tipoRemessa">
                    Tipo de remessa <TextError>*</TextError>
                  </Label>
                  <SelectComponent
                    color="black"
                    placeholder="Selecione tipo da remessa"
                    id="tipoRemessa"
                    width={Number("100%")}
                    name="tipoRemessa"
                    disabled={isRequest}
                    value={typeRemittance}
                    onChange={(e) => {
                      setTypeRemittance(e.target.value as TypeRemessa);
                      clearError(e);
                    }}
                    options={[
                      { value: TypeRemessa.BOLETO, label: "Boleto" },
                      {
                        value: TypeRemessa.DEBITO_AUTOMATICO,
                        label: "Débito Automático",
                      },
                    ]}
                    errorMessage={
                      invalidFields.includes("tipoRemessa")
                        ? "A seleção do tipo de remessa é obrigatória"
                        : ""
                    }
                  /> */}

                <Label htmlFor="localPagamento">
                  Local de Pagamento <TextError>*</TextError>
                </Label>
                <SelectComponent
                  color="black"
                  placeholder="Selecione"
                  id="localPagamento"
                  width={Number("100%")}
                  name="localPagamento"
                  disabled={isRequest}
                  value={selectLocalPagamento?.id?.toString() ?? ""}
                  onChange={(e) => {
                    const selectedLocal = locaisPagamento.find(
                      (local) => local.id === parseInt(e.target.value)
                    );
                    setSelectLocalPagamento(selectedLocal);
                    clearError(e);
                  }}
                  options={locaisPagamento.map((local) => ({
                    value: local.id!.toString(),
                    label: local.descricao,
                  }))}
                  errorMessage={
                    invalidFields.includes("localPagamento")
                      ? "A seleção do local de pagamento é obrigatória"
                      : ""
                  }
                />

                <Label htmlFor="lotacao">Lotação</Label>
                <SelectComponent
                  color="black"
                  placeholder="Todas"
                  isPlaceHolder={false}
                  id="lotacao"
                  width={Number("100%")}
                  name="lotacao"
                  disabled={isRequest}
                  value={selectLotacao?.id?.toString() ?? ""}
                  onChange={(e) => {
                    if (e.target.value === "0") {
                      setSelectLotacao({ id: 0, descricao: "Sem Lotacao" });
                    } else {
                      const selectedLotacao = lotacoes.find(
                        (lotacao) => lotacao.id === parseInt(e.target.value)
                      );
                      setSelectLotacao(selectedLotacao);
                    }
                    clearError(e);
                  }}
                  options={[
                    { value: "0", label: "Sem lotação" },
                    ...lotacoes.map((lotacao) => ({
                      value: lotacao.id!.toString(),
                      label: lotacao.descricao,
                    })),
                  ]}
                  errorMessage={
                    invalidFields.includes("lotacao")
                      ? "A seleção da lotação é obrigatória"
                      : ""
                  }
                />

                <Label className="filtro-label" htmlFor="dataVencimento">
                  Data de vencimento <TextError>*</TextError>
                </Label>
                <DatePickerInputContainer
                  width={Number("100%")}
                  hasIconLeft={false}
                  hasIconRight={false}
                  error={
                    invalidFields.includes("dataVencimento") ? true : false
                  }
                  className={
                    dateRange[0] || dateRange[1] ? "has-date-content" : ""
                  }
                >
                  <DatePicker
                    selectsRange={true}
                    name="dataVencimento"
                    startDate={dateRange[0] as Date | undefined}
                    endDate={dateRange[1] as Date | undefined}
                    onChange={(dates) => {
                      handleDateRangeChange(
                        dates as [Date | null, Date | null]
                      );

                      setInvalidFields((prev) =>
                        prev.filter((field) => field !== "dataVencimento")
                      );
                    }}
                    onChangeRaw={handleDateInputChange}
                    calendarStartDay={0}
                    className={`date-picker-input placeholder-custom ${
                      dateRange[0] || dateRange[1] ? "has-value" : "no-value"
                    }`}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="00/00/0000 - 00/00/0000"
                    showPopperArrow={false}
                    popperPlacement="bottom-start"
                    isClearable={false}
                    showYearDropdown
                    showMonthDropdown
                    scrollableMonthYearDropdown
                    wrapperClassName={
                      dateRange[0] || dateRange[1]
                        ? "date-wrapper-filled"
                        : "date-wrapper-empty"
                    }
                    locale="pt-BR"
                    autoComplete="off"
                    allowSameDay
                    onKeyDown={(e) => {
                      if (e.key === "Delete" || e.key === "Backspace") {
                        setDateRange([undefined, undefined]);
                        return;
                      }
                    }}
                  />
                </DatePickerInputContainer>
                {invalidFields.includes("dataVencimento") && (
                  <TextError>
                    Preencha a data de vencimento corretamente
                  </TextError>
                )}
                {totalFichasFinanceiras !== undefined &&
                totalFichasFinanceiras >= 0 ? (
                  <ContainerCount>
                    <Label fontSize={14}>{`A consulta retornou`}</Label>
                    <LabelCountBlue>{totalFichasFinanceiras}</LabelCountBlue>
                    <Label
                      fontSize={14}
                    >{`ficha(s) financeira(s) para remessa.`}</Label>
                  </ContainerCount>
                ) : null}
                {totalFichasFinanceirasBaixa !== undefined &&
                totalFichasFinanceirasBaixa > 0 ? (
                  <ContainerCount>
                    <Label fontSize={14}>{`Existem `}</Label>
                    <LabelCountRed>{totalFichasFinanceirasBaixa}</LabelCountRed>
                    <Label fontSize={14}>
                      {` ficha(s) financeira(s) cancelada(s) para essa remessa.`}
                    </Label>
                  </ContainerCount>
                ) : null}
              </ModalBody>
              <ModalFooter>
                <Button
                  schemaButton="full-primary"
                  action={() => {
                    createRemittanceMass(totalFichasFinanceirasBaixa);
                  }}
                  disabled={
                    isRequest &&
                    totalFichasFinanceiras <= 0 &&
                    totalFichasFinanceirasBaixa <= 0
                  }
                >
                  Gerar remessa
                </Button>
              </ModalFooter>
            </ModalContent>
          </ModalContainer>

          <ModalContainer show={showModalUploadRemittance}>
            <ModalContent>
              <Button
                type="button"
                schemaButton="x-close"
                action={() => setShowModalUploadRemittance(false)}
                icon={<IoCloseSharp size={30} />}
                position="absolute"
                top={10}
                right={10}
              />
              <ModalHeader>
                <BlueTitle>Carregar arquivo de retorno</BlueTitle>
              </ModalHeader>
              <ModalBody>
                <Label>Selecione o arquivo</Label>
                <Form.Group controlId="formFile" className="mb-3">
                  <Form.Label>Selecione apenas arquivos de retorno</Form.Label>
                  <Form.Control
                    type="file"
                    onChange={handleFileChange}
                    placeholder="Selecione um arquivo"
                    ref={fileInputRef}
                  />
                </Form.Group>
              </ModalBody>
              <ModalFooter>
                <Button
                  schemaButton="full-primary"
                  action={() => {
                    handleUploadReturnRemittance();
                  }}
                  disabled={isRequest}
                >
                  Carregar arquivo
                </Button>
              </ModalFooter>
            </ModalContent>
          </ModalContainer>
        </Container>
      ) : (
        <LoadingOverlay>
          <LoadingGif src={loadSCGif} alt="Carregando..." />
        </LoadingOverlay>
      )}
    </>
  );
};

export default Remessas;
